import { useMemo, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { deepMerge } from 'grommet/utils';
import _ from 'lodash';
import { updatePreferences } from 'granite-admin/common/ducks/preferences';
import { useToast } from 'granite-admin/core/components/Toast';
import { useDeepCompareCallback } from 'granite-admin/core/components/TableV3';
import userPrefApi from 'granite-admin/common/gateways/user-preferences-api';
function usePreferences(props) {
  const {
    component,
    showPreferenceToast = true,
    route = '',
    excludeFromPreference = [],
    autoSavePreference = false
  } = props || {};
  const {
    successToast,
    errorToast
  } = useToast();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const preferences = useSelector(({
    common
  }) => common.preferences.preferences);
  const {
    path: url,
    params
  } = useRouteMatch();
  const path = useMemo(() => {
    if (route) return route;
    let theUrl = url;
    Object.keys(params).forEach(key => {
      if (key.includes('sr_')) theUrl = theUrl?.replace(`:${key}`, params[key]);
    });
    return component ? `${theUrl}_${component}` : theUrl;
  }, [url, params, component, route]);
  const getUserPreferences = useCallback(async () => {
    try {
      setFetchLoading(true);
      let prefs = await userPrefApi.getPreferences(path);
      let updatedPreferences = {};
      updatedPreferences[path] = {
        ...(prefs.length > 0 ? prefs[0] : {})
      };
      dispatch(updatePreferences(updatedPreferences));
    } catch {
      if (showPreferenceToast) errorToast('Unable to get preferences.');
    } finally {
      setFetchLoading(false);
    }
  }, [path, errorToast, dispatch, showPreferenceToast]);
  const saveUserPreferences = useDeepCompareCallback(async payload => {
    try {
      let filteredConfig = _.cloneDeep({
        ...(payload?.config ?? {})
      });
      excludeFromPreference.forEach(key => {
        if (_.get(filteredConfig, key)) {
          _.unset(filteredConfig, key);
        }
      });
      let prefs = {};
      setLoading(true);
      if (autoSavePreference && Object.keys(preferences?.[path] ?? {}).length > 0) {
        prefs = await userPrefApi.updatePreferences({
          ...payload,
          config: filteredConfig
        }, preferences[path].pk);
      } else if (autoSavePreference) {
        prefs = await userPrefApi.createPreferences({
          ...payload,
          config: filteredConfig
        });
      }
      let updatedPreferences = {};
      updatedPreferences[path] = deepMerge(payload, prefs);
      dispatch(updatePreferences(updatedPreferences));
      setLoading(false);
      if (showPreferenceToast) successToast('Preferences Saved.');
      return prefs;
    } catch (err) {
      setLoading(false);
      if (showPreferenceToast) errorToast('Unable to save preferences.');
    }
  }, [preferences, errorToast, successToast, dispatch, showPreferenceToast, path, excludeFromPreference]);
  const savePreference = async (key, data) => {
    const payload = {
      route_path: path,
      config: key === 'layout' ? {
        layout: data
      } : _.pickBy(data, _.identity)
    };
    await saveUserPreferences(payload);
  };

  // const getPreference = (key) => {
  //   console.log(Math.floor(Math.random() * 10))
  //   return preferences[path]?.[key];
  // };

  const deletePreference = key => {
    const update = {
      ...preferences
    };
    delete update[path]?.key;
    dispatch(updatePreferences(update));
  };
  useEffect(() => {
    if (autoSavePreference && !preferences[path]) getUserPreferences();else setFetchLoading(false);
  }, [getUserPreferences, autoSavePreference, preferences, path]);
  // console.log('preferences', preferences)
  return {
    savePreference,
    // getPreference,
    deletePreference,
    preferences: preferences?.[path] ?? {},
    loading,
    fetchLoading
  };
}
export default usePreferences;